import React, {useState, useMemo, useEffect} from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import {
  DataGridPremium,
} from '@mui/x-data-grid-premium'
import { useAutoEvent } from '../../queries/useAutoEvent'
import { useParams } from 'react-router'
import { useHistory, useLocation } from 'react-router-dom'
import { EventState, setEvent, useEventState } from '../../slices/eventSlice'
import { makeStyles, Button } from '@material-ui/core'
import SearchBar from '../../components/common/inputs/SearchBar'
import axios from "axios";
import {usePutGuestLink} from "../../queries/events/useFetchGuestLink";
interface Params {
  eventid: string
}

const useStyle = makeStyles({
  root: {
    '& .MuiDataGrid-columnHeaderTitle': {
      overflow: 'visible',
      lineHeight: '1.43rem',
      whiteSpace: 'normal'
    }
  }
})

const GuestLinkingPage = () => {
  const { eventid } = useParams<Params>()
  const history = useHistory()
  useAutoEvent(eventid)
  const event = useEventState()
  const [searchP, setsearchP] = useState({ipk:undefined, multi:undefined})
  const [rowsErrorMessage, setRowsErrorMessage] = useState<string>('')
  const [rows, setRows] = useState([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const putLink = usePutGuestLink()

  const propPass: any = useLocation()
  const guestInfo = propPass.state?.data

  useEffect(() => {
    getLinkingData()
  }, [searchP])

  const getLinkingData = async () => {
    setIsLoading(true)
    var body = { eventid: eventid, guestid:guestInfo.guestid }

    if (searchP.multi) {
      body['search'] = searchP.multi
    }

    if (searchP.ipk) {
      body['contactid'] = Number(searchP.ipk)
    }

    const { data } = await axios.post('/guestlinklookup', body)
    const parsedData = JSON.parse(data.jsonString)

    if (parsedData?.contactdata?.length > 0 && parsedData.contactdata[0].message) {
      setRows([])
      setRowsErrorMessage(parsedData.contactdata[0].message)
    }
    else {
      setRows(parsedData?.contactdata)
      setRowsErrorMessage('')
    }
    setIsLoading(false)
  }
  const onClickMultiSearch = (searchString) => {
      setsearchP({ipk:null, multi:searchString})
  }
  const onClickIPKSearch = (ipk) => {
      setsearchP({ipk:ipk, multi:null})
  }

  const columns = [
    {
      field: 'buttons',
      headerName: 'Link',
      width: 150,
      disableExport: true,
      sortable: false,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              putLink.mutate(
                  {
                    eventid: eventid,
                    contactid: params.row.contactid,
                    guestid: guestInfo.guestid
                  },
                  {
                    onSuccess: (data) => {
                      history.push(
                          '/event/' + eventid + '/eventguestlink'
                      )
                    }
                  }
              )
            }}>
            Link
          </Button>
        )
      }
    },
    { field: 'rownumber', headerName: 'rownumber' },
    {
      field: 'contactid',
      type: 'string',
      headerName: 'Contact ID',
      width: 100,
      editable: false
    },
    {
      field: 'first',
      type: 'string',
      headerName: 'First Name',
      width: 200,
      editable: true
    },
    {
      field: 'last',
      type: 'string',
      headerName: 'Last Name',
      width: 200,
      editable: true
    },
    {
      field: 'email',
      type: 'string',
      headerName: 'Email',
      width: 200,
      editable: false
    },
    {
      field: 'first2',
      type: 'string',
      headerName: 'First Name 2',
      width: 200,
      editable: true
    },
    {
      field: 'last2',
      type: 'string',
      headerName: 'Last Name 2',
      width: 200,
      editable: true
    },
    {
      field: 'email2',
      type: 'string',
      headerName: 'Email 2',
      width: 200,
      editable: false
    },
    {
      field: 'phone',
      type: 'string',
      headerName: 'Phone',
      valueFormatter: (params) => {
        var cleaned = ('' + params.value).replace(/\D/g, '')
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        return match
          ? '(' + match[1] + ') ' + match[2] + '-' + match[3]
          : params.value
      },
      width: 200,
      editable: true
    },
    {
      field: 'cell',
      type: 'string',
      headerName: 'Cell',
      valueFormatter: (params) => {
        var cleaned = ('' + params.value).replace(/\D/g, '')
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        return match
          ? '(' + match[1] + ') ' + match[2] + '-' + match[3]
          : params.value
      },
      width: 200,
      editable: true
    },
    {
      field: 'company',
      type: 'string',
      headerName: 'Company',
      width: 200,
      editable: true
    },
    {
      field: 'address1',
      type: 'string',
      headerName: 'Address',
      width: 200,
      editable: true
    },
    {
      field: 'paddlenumbertext',
      type: 'string',
      headerName: 'Paddle Number',
      width: 200,
      editable: true
    }
  ]
  const classes = useStyle()

  return (
    <div>
      <Box m={1}
        display="flex"
        justifyContent="flex-end"
        alignItems="flex-end">
        <Paper sx={{ flex: 1, mx: 'auto', width: '90%', p: 1 }}>
            <Stack direction="column" spacing={1} sx={{ height: 1 }}>
              <Typography align="center" variant="h6">{`Participant # ${guestInfo.guestid}`}</Typography>
              <Grid container>
                <Grid item md={4}>

                  <Typography align="center" variant="body1">{`${guestInfo.first} ${guestInfo.last}`}</Typography>
                  <Typography align="center" variant="body1">{guestInfo.address}</Typography>
                </Grid>
                <Grid item md={4} >
              
                  <Typography align="center" variant="body1">{`${guestInfo.email}`}</Typography>
                  <Typography align="center" variant="body1">{guestInfo.city}</Typography>
                </Grid>
                 <Grid item md={4}>
                  <Typography align="center" variant="body1">{guestInfo.phone}</Typography>
                  <Typography align="center" variant="body1">{`${guestInfo.state} ${guestInfo.zip}`}</Typography>
                </Grid>
              </Grid>
            </Stack>
          </Paper>
          </Box>
          <Box>
          <Grid container>
              <Grid item md={7}>
                <Box m ={1}>
                  <SearchBar placeHolder="Search name, email, phone, company, or address" onClick ={onClickMultiSearch} />
                </Box>
              </Grid>
              <Grid item md={1} >
              </Grid>
                <Grid item md={4} >
                  <Box m ={1}>
                    <SearchBar type="number" placeHolder="Search ContactIPK" onClick ={onClickIPKSearch} />
                  </Box>
                </Grid>
              </Grid>
          </Box>
      <DataGridPremium
        components={{
          NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {rowsErrorMessage?.length > 0 ? rowsErrorMessage : 'No Rows'}
              </Stack>
          ),
          NoResultsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {rowsErrorMessage?.length > 0 ? rowsErrorMessage : 'No Rows'}
              </Stack>
          )
        }}
        getRowId={(row) => row.rownumber}
        className={classes.root}
        autoHeight
        columns={columns}
        rows={rows}
        loading={isLoading}
        rowThreshold={0}
        columnVisibilityModel={{
          // Hide column rownumber the other columns will remain visible
          rownumber: false
        }}
      />
    </div>
  )
}
export default GuestLinkingPage
